var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"big-font"},[_vm._v(" page-404 "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(_vm._s(_vm.$t('page404.goHome')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }